import { tap } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { createBranch, Branch, createAuthTransferService } from '@golden/gdk-base';
import { extendObj } from '@golden/utils';
export function createAuthService(api, trunk, isLoginSubject, isWrongSubject) {
    createBranch({
        trunk,
        branch: Branch.ADMIN_STATUS,
        value: { is_ip_in_whitelist: true },
        operator: () => api.fetch(ADMIN_API.ADMIN_STATUS)
            .pipe(tap((res) => isWrongSubject.next(!res.is_ip_in_whitelist)))
    });
    const authTransferService = createAuthTransferService('admin/', api);
    return extendObj(authTransferService, {
        login(adminLoginReq) {
            return api.fetch(ADMIN_API.ADMIN_LOGIN, {
                data: { account: adminLoginReq.account, password: adminLoginReq.password, code: adminLoginReq.code }
            }).pipe(tap(() => {
                isLoginSubject.next(true);
            }));
        },
        logout() {
            trunk.next([Branch.CLEAR]);
            isLoginSubject.next(false);
            return api.fetch(ADMIN_API.ADMIN_LOGOUT);
        },
        get isWrong() {
            return isWrongSubject;
        },
        get isLoggedIn() {
            return isLoginSubject;
        },
        issueAuthenticator() {
            return api.fetch(ADMIN_API.GET_ISSUE_AUTHENTICATOR);
        },
        validateAuthenticator(code) {
            return api.fetch(ADMIN_API.POST_VALIDATE_AUTHENTICATOR, { data: { code } });
        },
        deleteAuthenticator(id) {
            return api.fetch(ADMIN_API.DELETE_AUTHENTICATOR, { config: { urlParams: { id } } });
        }
    });
}
//# sourceMappingURL=AuthService.js.map